import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getPersonalizedConfigOption } from "~/store/selectors/selector.configOptions";
import { getUserTaskIdsSortByDate } from "~/store/selectors/selector.userTasks";

export const useMyWorkByDateTaskNavigation = (taskId, userId) => {
  let previous, next;
  const configOptionName = useMemo(
    () =>
      Array.isArray(userId)
        ? "team_tasks_group_by"
        : userId
        ? "user_profile_tasks_group_by"
        : "my_work_tasks_grouped_by",
    [userId]
  );
  const groupBy = useSelector((state) => getPersonalizedConfigOption(state, configOptionName));

  const taskIds = useSelector((state) => getUserTaskIdsSortByDate(state, groupBy, userId));

  const currentIndex = taskIds.indexOf(taskId);
  previous = currentIndex > -1 && taskIds[currentIndex - 1] ? taskIds[currentIndex - 1] : null;
  next = currentIndex > -1 && taskIds[currentIndex + 1] ? taskIds[currentIndex + 1] : null;

  return [previous, next];
};
